import ImageAssets from "../../assets";

export const carouselJson: any = [
  {
    src: ImageAssets.ic_growtogether,
    headerText: "Network & Collaborate with Artists",
    // description: "Building Community with purpose, purspective and style",
  },
  {
    src: ImageAssets.ic_artist,
    headerText: "All artists are welcome here",
    // description: "Join SEKERON Today and Discover other artists driven passion",
  },
  {
    src: ImageAssets.ic_intro_croussel,
    headerText: "What's in it for you?",
    // description: "Join SEKERON Today and Discover other artists driven passion",
  },
];
